
export default {
  name: "Footer",
  props: {
    lang: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      localLang: "en", // 添加本地语言变量
      isMobile: false,
      showCopyTips: false,
      copyIconColor: "#409EFF",
      isDisabled: false,
      useCookie: null,
      activeSection: [false, false, false],

      // 页脚链接数据
      footerLinks: [
        {
          name: {
            en: "Products",
            zh: "产品",
            kr: "제품",
            de: "Produkte",
            jp: "製品",
            fr: "Produits",
            pt: "Produtos",
            es: "Productos",
            id: "Produk",
          },
          value: [
            {
              text_en: "AI Image Upscaler",
              text_zh: "AI图像放大",
              text_kr: "AI 이미지 업스케일러",
              text_de: "AI-Bildvergrößerer",
              text_jp: "AI画像アップスケーラー",
              text_fr: "Agrandisseur d'image AI",
              text_pt: "Ampliador de Imagem AI",
              text_es: "Ampliador de Imágenes AI",
              text_id: "Peningkat Gambar AI",
              href: "https://remaker.ai/features/ai-image-upscaler/",
            },
            {
              text_en: "AI Headshot Generator",
              text_zh: "AI证件照",
              text_kr: "AI 증명사진 생성기",
              text_de: "KI-Kopfschussgenerator",
              text_jp: "AIヘッドショットジェネレーター",
              text_fr: "Générateur de Portraits AI",
              text_pt: "Gerador de Fotos de Rosto com IA",
              text_es: "Generador de Fotos de Perfil con IA",
              text_id: "Generator Foto Profil AI",
              href: "https://remaker.ai/ai-headshot-generator/",
            },
            {
              text_en: "AI Portrait Generator",
              text_zh: "AI写真",
              text_kr: "AI 초상화 생성기",
              text_de: "KI-Portrait-Generator",
              text_jp: "AI ポートレートジェネレーター",
              text_fr: "Générateur de Portraits IA",
              text_pt: "Gerador de Retratos com IA",
              text_es: "Generador de Retratos AI",
              text_id: "Generator Potret AI",
              href: "https://remaker.ai/features/ai-portrait/",
            },
            {
              text_en: "AI Image Generator",
              text_zh: "AI图像生成器",
              text_kr: "AI 이미지 생성기",
              text_de: "KI-Bilder-Generator",
              text_jp: "AI 画像ジェネレーター",
              text_fr: "Générateur d'Images IA",
              text_pt: "Gerador de Imagens com IA",
              text_es: "Generador de Imágenes AI",
              text_id: "Generator Gambar AI",
              href: "https://remaker.ai/features/ai-image-generator/",
            },
            {
              text_en: "AI Logo Generator",
              text_zh: "AI Logo 生成器",
              text_kr: "AI 로고 생성기",
              text_de: "AI-Logo-Generator",
              text_jp: "AIロゴジェネレーター",
              text_fr: "Générateur de logo AI",
              text_pt: "Gerador de Logotipo AI",
              text_es: "Generador de logotipos AI",
              text_id: "Generator Logo AI",
              href: "https://remaker.ai/features/ai-logo-generator/",
            },
            {
              text_en: "AI Video Enhancer",
              text_zh: "AI视频画质增强",
              text_kr: "AI 비디오 향상",
              text_de: "KI-Video-Verbesserer",
              text_jp: "AI ビデオエンハンサー",
              text_fr: "Améliorateur de Vidéo IA",
              text_pt: "Melhorador de Vídeo com IA",
              text_es: "Mejorador de Video AI",
              text_id: "Peningkat Video AI",
              href: "https://remaker.ai/video-enhancer/",
            },
            {
              text_en: "AI Background Remover",
              text_zh: "AI背景去除器",
              text_kr: "AI 배경 제거",
              text_de: "KI-Hintergrundentferner",
              text_jp: "AI 背景除去",
              text_fr: "Supprimeur de Fond IA",
              text_pt: "Removedor de Fundo com IA",
              text_es: "Eliminador de Fondo AI",
              text_id: "Penghapus Latar Belakang AI",
              href: "https://remaker.ai/features/remove-background/",
            },
            {
              text_en: "More Features",
              text_zh: "更多功能",
              text_kr: "더 많은 기능",
              text_de: "Weitere Funktionen",
              text_jp: "より多くの機能",
              text_fr: "Plus de fonctionnalités",
              text_pt: "Mais Recursos",
              text_es: "Más Funciones",
              text_id: "Fitur Lebih Lanjut",
              href: "https://remaker.ai/features/",
            },
          ],
        },
        {
          name: {
            en: "Resources",
            zh: "资源",
            kr: "리소스",
            de: "Ressourcen",
            jp: "リソース",
            fr: "Ressources",
            pt: "Recursos",
            es: "Recursos",
            id: "Sumber Daya",
          },
          value: [
            {
              text_en: "Pricing",
              text_zh: "价格",
              text_kr: "가격",
              text_de: "Preisgestaltung",
              text_jp: "料金",
              text_fr: "Tarification",
              text_pt: "Preços",
              text_es: "Precios",
              text_id: "Harga",
              href: "https://remaker.ai/pricing/",
            },
          ],
        },
        {
          name: {
            en: "About",
            zh: "关于",
            kr: "소개",
            de: "Über",
            jp: "概要",
            fr: "À propos",
            pt: "Sobre",
            es: "Acerca de",
            id: "Tentang",
          },
          value: [
            {
              text_en: "Privacy and Cookies Policy",
              text_zh: "隐私和Cookie政策",
              text_kr: "개인 정보 및 쿠키 정책",
              text_de: "Datenschutz- und Cookie-Richtlinie",
              text_jp: "プライバシーとクッキーポリシー",
              text_fr: "Politique de confidentialité et de cookies",
              text_pt: "Política de Privacidade e Cookies",
              text_es: "Política de Privacidad y Cookies",
              text_id: "Kebijakan Privasi dan Cookies",
              href: "https://remaker.ai/en/privacy-and-cookies-policy/",
            },
            {
              text_en: "Terms and Conditions",
              text_zh: "条款和条件",
              text_kr: "이용약관",
              text_de: "Geschäftsbedingungen",
              text_jp: "利用規約",
              text_fr: "Termes et conditions",
              text_pt: "Termos e Condições",
              text_es: "Términos y Condiciones",
              text_id: "Syarat dan Ketentuan",
              href: "https://remaker.ai/en/terms-and-conditions/",
            },
            {
              text_en: "Extension Privacy Policy",
              text_zh: "扩展隐私政策",
              text_kr: "확장 개인정보 정책",
              text_de: "Erweiterte Datenschutzrichtlinie",
              text_jp: "拡張プライバシーポリシー",
              text_fr: "Politique de confidentialité de l'extension",
              text_pt: "Política de Privacidade da Extensão",
              text_es: "Política de Privacidad de la Extensión",
              text_id: "Kebijakan Privasi Ekstensi",
              href: "https://remaker.ai/en/extension-privacy-policy/",
            },
            {
              text_en: "Content Policy",
              text_zh: "内容政策",
              text_kr: "콘텐츠 정책",
              text_de: "Inhaltspolitik",
              text_jp: "コンテンツポリシー",
              text_fr: "Politique de contenu",
              text_pt: "Política de Conteúdo",
              text_es: "Política de Contenidos",
              text_id: "Kebijakan Konten",
              href: "https://remaker.ai/en/content-policy/",
            },
          ],
        },
      ],

      // 社交媒体链接
      entryImageList: [
        {
          enterUrl: "https://www.facebook.com/remakerai",
          src: "https://remaker.ai/userspace/saasbox/image/remaker-home/smEnter1.png",
          alt: "",
        },
        {
          enterUrl: "https://x.com/Remaker_X",
          src: "https://remaker.ai/userspace/saasbox/image/remaker-home/smEnter2.png",
          alt: "",
        },
        {
          enterUrl: "https://www.youtube.com/@RemakerAI-en",
          src: "https://remaker.ai/userspace/saasbox/image/remaker-home/smEnter3.png",
          alt: "",
        },
      ],

      // Cookie文本
      cookieText: {
        en: {
          message: "We use cookies to enhance your experience. By clicking",
          accept: "Accept",
          agree:
              "you acknowledge that you have read, understood, and agreed to our",
          policy: "Cookie Policy",
        },
        zh: {
          message: "我们使用Cookie来提升您的体验。点击",
          accept: "接受",
          agree: "您确认您已阅读、理解并同意我们的",
          policy: "Cookie政策",
        },
        kr: {
          message:
              "우리는 귀하의 경험을 향상시키기 위해 쿠키를 사용합니다. 클릭",
          accept: "수락",
          agree: "귀하는 당사의 내용을 읽고 이해하고 동의했음을 인정합니다",
          policy: "쿠키 정책",
        },
        de: {
          message:
              "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Durch Klicken",
          accept: "Akzeptieren",
          agree:
              "erkennen Sie an, dass Sie unsere gelesen, verstanden und akzeptiert haben",
          policy: "Cookie-Richtlinie",
        },
        jp: {
          message:
              "私たちはあなたの体験を向上させるためにCookieを使用します。クリック",
          accept: "同意する",
          agree: "あなたは私たちの内容を読み、理解し、同意したことを認めます",
          policy: "クッキーポリシー",
        },
        fr: {
          message:
              "Nous utilisons des cookies pour améliorer votre expérience. En cliquant",
          accept: "Accepter",
          agree: "vous reconnaissez avoir lu, compris et accepté notre",
          policy: "Politique de cookies",
        },
        pt: {
          message: "Usamos cookies para melhorar sua experiência. Ao clicar",
          accept: "Aceitar",
          agree: "você reconhece que leu, entendeu e concordou com nossa",
          policy: "Política de Cookies",
        },
        es: {
          message: "Usamos cookies para mejorar su experiencia. Al hacer clic",
          accept: "Aceptar",
          agree: "usted reconoce que ha leído, entendido y aceptado nuestra",
          policy: "Política de Cookies",
        },
        id: {
          message:
              "Kami menggunakan cookies untuk meningkatkan pengalaman Anda. Dengan mengklik",
          accept: "Terima",
          agree:
              "Anda mengakui bahwa Anda telah membaca, memahami, dan menyetujui",
          policy: "Kebijakan Cookie kami",
        },
      },

      // 联系文本
      contactText: {
        en: "Contact US",
        zh: "联系我们",
        kr: "문의하기",
        de: "Kontaktiere uns",
        jp: "お問い合わせ",
        fr: "Contactez-nous",
        pt: "Contate-nos",
        es: "Contáctanos",
        id: "Hubungi Kami",
      },

      // 复制成功文本
      copyText: {
        en: "Copy successful.",
        zh: "复制成功。",
        kr: "복사 성공.",
        de: "Kopieren erfolgreich.",
        jp: "コピー成功。",
        fr: "Copie réussie.",
        pt: "Cópia bem-sucedida.",
        es: "Copia exitosa.",
        id: "Salinan berhasil.",
      },

      // 语言映射
      langMapUrl: {
        zh: "版权所有 2025 Remaker AI。保留所有权利。",
        kr: "저작권 2025 Remaker AI. 모든 권리 보유.",
        de: "Urheberrecht 2025 Remaker AI. Alle Rechte vorbehalten.",
        jp: "著作権 2025 Remaker AI. 無断複写を禁じます。",
        fr: "Droits d'auteur 2025 Remaker AI. Tous droits réservés.",
        pt: "Direitos autorais 2025 Remaker AI. Todos os direitos reservados.",
        es: "Derechos de autor 2025 Remaker AI. Todos los derechos reservados.",
        id: "Hak Cipta 2025 Remaker AI. Semua hak dilindungi undang-undang.",
      },

      // 语言URL映射
      langMapUrlFoot: {
        "/zh/": "zh",
        "/kr/": "kr",
        "/de/": "de",
        "/jp/": "jp",
        "/fr/": "fr",
        "/pt/": "pt",
        "/es/": "es",
        "/id/": "id",
      },
    };
  },
  mounted() {
    if (process.client) {
      this.initLang();
      this.checkMobile();
      const storedCookie = localStorage.getItem('use_cookie');
      this.useCookie = storedCookie === 'true';
      window.addEventListener("resize", this.handleResize);
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  watch: {
    $route(to, from) {
      this.initLang();
    },
    // 监听prop变化，更新本地变量
    lang: {
      immediate: true,
      handler(newVal) {
        this.localLang = newVal;
      }
    }
  },
  methods: {
    initLang() {
      if (process.client) {
        const pathUrl = window.location.pathname;
        const urlKeys = Object.keys(this.langMapUrlFoot);
        const langKey = urlKeys.find((key) => pathUrl.includes(key));
        this.localLang = langKey ? this.langMapUrlFoot[langKey] : "en";
      } else {
        this.localLang = "en";
      }
    },
    checkMobile() {
      if (process.client) {
        this.isMobile =
            navigator.userAgent.includes("mobile") || window.innerWidth < 1050;
      } else {
        this.isMobile = false;
      }
    },
    handleResize() {
      if (process.client) {
        this.isMobile = window.innerWidth < 1050;
      }
    },
    toggleSection(index) {
      if (!this.isMobile) return;
      this.activeSection = this.activeSection.map((_, i) =>
          i === index ? !this.activeSection[i] : false
      );
    },
    async copyEmail() {
      if (!process.client) return;
      const email = 'vip.remaker@gmail.com'
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(email)
          this.$message.success('复制成功')
          return
        }
        const textArea = document.createElement('textarea')
        textArea.value = email
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          const successful = document.execCommand('copy')
          if (successful) {
            this.$message.success('复制成功')
          } else {
            this.$message.error('复制失败，请手动复制')
          }
        } catch (err) {
          this.$message.error('复制失败，请手动复制')
        }
        document.body.removeChild(textArea)
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
    },
    closeCopyTips() {
      this.showCopyTips = false;
    },
    closeCookie() {
      this.useCookie = true;
      if (process.client) {
        localStorage.setItem("use_cookie", "true");
      }
    },
    acceptCookie() {
      this.closeCookie();
    },
  },
};
